// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3omTi","name":"ConsentHeader_name__1Yts3","birthday":"ConsentHeader_birthday__1PmaB","skeleton":"ConsentHeader_skeleton__2Qb77"};